import StandardGateway from './lib/standard_gateway';

export default class RulesGateway extends StandardGateway {
  constructor(backend) {
    super(backend, 'v2/orgs/:orgId/rules/:id');
  }

  fetchAll(params, query) {
    const rstQuery = params.ruleSetType ? { 'f.rst': params.ruleSetType } : {};
    const queryParams = { ...query, ...rstQuery };
    return super.fetchAll(params, queryParams);
  }
}
